import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useHistory } from 'react-router';
import { actionsType, getFilters, getPagination } from '../../redux/actions';
import { ReduxState } from '../../redux/interface';
import './header.style.scss';

const Header: React.FC<ConnectedProps<typeof connector>> = (
    props: ConnectedProps<typeof connector>
) => {

    const history = useHistory();

    function drawerMenuOnClickHandler() {
        props.dispatch({
            type: actionsType.toggleDrawerMenu,
        });
    }

    function handleResetPage() {
        props.dispatch(
            getPagination({
                page: 1,
            })
        );
    }

    function search(e: any) {
        const query = e.target.value;
        history.replace('/');
        handleResetPage();
        props.dispatch(
            getFilters({
                ...props.filters,
                query,
            })
        );
    }

    function handleKeyDown(e: any) {
        if (e.key === 'Enter') {
            search(e);
            e.target.value = '';
            e.target.blur();
        }
    }

    return (
        <div className="wom-header">
            <div className="header-search">
                <input
                    type="text"
                    placeholder="Search Movie ..."
                    onFocus={(e) => (e.target.placeholder = '')}
                    onBlur={(e) => (e.target.placeholder = 'Search Movie ...')}
                    onKeyDown={handleKeyDown}
                />
                <i className="material-icons">search</i>
            </div>
            {/* <div className="header-saved">
                <i className="material-icons">bookmark</i>
            </div> */}
            <div className="header-bars">
                <i className="material-icons" onClick={drawerMenuOnClickHandler}>
                    {props.drawerMenuStatus ? 'close' : 'menu'}
                </i>
            </div>
        </div>
    )
}

const mapStateToProps = (state: ReduxState) => {
    return {
        drawerMenuStatus: state.drawerMenuStatus,
        filters: state.filters,
    };
};

const connector = connect(mapStateToProps);
export default connector(Header);
